var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "seg-content general user" }, [
    _c(
      "form",
      {
        staticClass: "user-form login",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.saveProfile($event)
          }
        }
      },
      [
        _c("div", { staticClass: "uf-row split" }, [
          _c("div", [
            _c("label", [_vm._v("Username")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userProfile.username,
                  expression: "userProfile.username"
                }
              ],
              attrs: { type: "text", readonly: "", placeholder: "Username" },
              domProps: { value: _vm.userProfile.username },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.userProfile, "username", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", [_vm._v("Email Address")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userProfile.email,
                  expression: "userProfile.email"
                }
              ],
              attrs: { type: "email", placeholder: "Email Address" },
              domProps: { value: _vm.userProfile.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.userProfile, "email", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "uf-row split" }, [
          _c("div", [
            _c("label", [_vm._v("First Name")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userProfile.firstname,
                  expression: "userProfile.firstname"
                }
              ],
              attrs: { type: "text", placeholder: "First Name" },
              domProps: { value: _vm.userProfile.firstname },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.userProfile, "firstname", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", [_vm._v("Last Name")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userProfile.lastname,
                  expression: "userProfile.lastname"
                }
              ],
              attrs: { type: "text", placeholder: "Last Name" },
              domProps: { value: _vm.userProfile.lastname },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.userProfile, "lastname", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "uf-row split" }, [
          _c("div", [
            _c("label", [_vm._v("Password")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userProfile.newPassword,
                  expression: "userProfile.newPassword"
                }
              ],
              attrs: { type: "password", placeholder: "Password" },
              domProps: { value: _vm.userProfile.newPassword },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.userProfile, "newPassword", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", [_vm._v("Confirm Password")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userProfile.confirmPassword,
                  expression: "userProfile.confirmPassword"
                }
              ],
              attrs: { type: "password", placeholder: "Confirm Password" },
              domProps: { value: _vm.userProfile.confirmPassword },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.userProfile,
                    "confirmPassword",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "uf-row to-c" }, [
      _c("button", { staticClass: "main" }, [_vm._v("Update")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }